module.exports = __webpack_public_path__ + "img/yt.e3c0a1b6.svg";